import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../../context/SiteContext';

export default function AboutPage() {
  const { getImage } = useSite();

  return (
    <div>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="container">
          <div className="crumb">
            <Link to="/">Trang chủ</Link> / <span>Giới thiệu</span>
          </div>
          <span className="eyebrow">Về Thế Thảo Pharma</span>
          <h1>
            Người đồng hành đáng tin cậy của
            <br />
            nhà thuốc Việt Nam.
          </h1>
          <p className="lead">
            Hơn một thập kỷ phân phối — Thế Thảo Pharma không chỉ giao hàng, mà giao niềm tin, giao sự an tâm và đồng hành cùng nhà thuốc phát triển bền vững.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="section">
        <div className="container about-grid">
          <div className="reveal">
            <span className="eyebrow">Câu chuyện</span>
            <h2>Khởi đầu từ một niềm tin: ngành dược cần sự tử tế</h2>
            <p>
              Tháng 12 năm 2014, Thế Thảo Pharma được thành lập tại Hà Nội với mong muốn trở thành nhà phân phối dược mỹ phẩm, thực phẩm chức năng và thiết bị y tế có trách nhiệm — nơi mỗi sản phẩm tới tay nhà thuốc đều được đảm bảo về chất lượng, pháp lý và minh bạch.
            </p>
            <p>
              Trải qua 12 năm, từ một nhóm nhỏ với chiếc xe máy đi giao hàng, Thế Thảo đã trở thành đối tác tin cậy của hơn <strong>20.000 nhà thuốc và quầy thuốc</strong> trên toàn quốc — chủ yếu là nhà thuốc truyền thống độc lập, những người đang đối mặt với sức ép từ chuỗi lớn và biến động thị trường.
            </p>
            <p>
              Slogan <em>"Chung tay vì một cuộc sống khoẻ đẹp"</em> không phải là khẩu hiệu — đó là kim chỉ nam cho mọi quyết định, mọi đơn hàng, mọi cuộc gọi hỗ trợ ngoài giờ làm việc.
            </p>
          </div>
          <div className="about-grid__art reveal">
            <img src="/assets/img/deco-rings.svg" alt="" className="about-grid__ring about-grid__ring--tl" aria-hidden="true" />
            <img src="/assets/img/deco-rings.svg" alt="" className="about-grid__ring about-grid__ring--br" aria-hidden="true" />
            <figure className="about-photo">
              <img
                src={getImage('gioithieu_story', 0, 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/gioithieu_story/0-1779247489761.webp')}
                alt="Câu chuyện Thế Thảo Pharma — khởi đầu từ một niềm tin"
                width="1200"
                height="900"
                loading="lazy"
              />
            </figure>
            <div className="badge">
              <strong>12 năm</strong>
              <span>Đồng hành cùng ngành dược</span>
            </div>
          </div>
        </div>
      </section>

      {/* Vision / Mission / Positioning */}
      <section className="section section--soft">
        <div className="container">
          <div className="text-center reveal" style={{ maxWidth: '680px', marginInline: 'auto' }}>
            <span className="eyebrow">Tầm nhìn — Sứ mệnh — Định vị</span>
            <h2>Ba ngọn hải đăng dẫn lối Thế Thảo</h2>
          </div>

          <div className="mission-grid">
            <div className="mission-card reveal">
              <div className="icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="9" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="12" cy="12" r="1" />
                </svg>
              </div>
              <h3>Tầm nhìn 2030</h3>
              <p>
                Trở thành đơn vị phân phối đồng hành <strong>hàng đầu Việt Nam</strong> — kết nối sản phẩm chất lượng với nhà thuốc, quầy thuốc toàn quốc; giúp nhà thuốc độc lập phát triển bền vững.
              </p>
            </div>
            <div className="mission-card reveal">
              <div className="icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s-8-7.6-8-13a8 8 0 0 1 16 0c0 5.4-8 13-8 13z" />
                  <circle cx="12" cy="9" r="2.5" />
                </svg>
              </div>
              <h3>Sứ mệnh</h3>
              <p>
                Mang đến sản phẩm <strong>tâm huyết — tinh tuý — chuẩn pháp lý</strong>, đồng hành cùng nhà thuốc nâng cao năng lực kinh doanh — vì một cộng đồng khoẻ mạnh và phát triển.
              </p>
            </div>
            <div className="mission-card reveal">
              <div className="icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M2 12l4-4 4 4 4-4 4 4 4-4" />
                  <path d="M2 18l4-4 4 4 4-4 4 4 4-4" />
                </svg>
              </div>
              <h3>Lý tưởng định vị</h3>
              <p>
                Lan toả những <strong>giá trị tử tế &amp; nhân văn</strong> trong ngành y dược Việt Nam. Trở thành người đồng hành đáng tin cậy — nơi nhà thuốc tìm đến khi cần sự hỗ trợ lâu dài và thực chất.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Giá trị cốt lõi */}
      <section className="section" id="gia-tri">
        <div className="container">
          <div className="text-center reveal" style={{ maxWidth: '720px', marginInline: 'auto' }}>
            <span className="eyebrow">Giá trị cốt lõi</span>
            <h2>Sáu giá trị định hình mọi quyết định</h2>
          </div>

          <div className="values-grid">
            <div className="value-card reveal">
              <div className="value-num">01</div>
              <h3>Niềm tin &amp; Uy tín</h3>
              <p className="value-quote">"Uy tín tạo niềm tin — Niềm tin tạo đồng hành"</p>
              <p>Mọi cam kết phải được thực hiện. Mỗi đơn hàng là một lời hứa về chất lượng, pháp lý và thời gian.</p>
            </div>
            <div className="value-card reveal">
              <div className="value-num">02</div>
              <h3>Học tập &amp; Đổi mới</h3>
              <p className="value-quote">"Ngừng học là ngừng phát triển"</p>
              <p>Đội ngũ trẻ, tư duy mở, không ngừng cập nhật xu hướng thị trường và công nghệ phục vụ nhà thuốc.</p>
            </div>
            <div className="value-card reveal">
              <div className="value-num">03</div>
              <h3>Trách nhiệm</h3>
              <p className="value-quote">"Tôi là gốc rễ mọi vấn đề — Tôi chịu trách nhiệm"</p>
              <p>Không đổ lỗi, không chờ đợi. Hành động với tinh thần "tôi sẽ giải quyết được" trong mọi tình huống.</p>
            </div>
            <div className="value-card reveal">
              <div className="value-num">04</div>
              <h3>Tử tế &amp; Biết ơn</h3>
              <p className="value-quote">"Làm điều đúng — trân trọng từng người, từng cơ hội"</p>
              <p>Giao tiếp chân thành, trân trọng từng nhà thuốc dù nhỏ hay lớn. Tử tế là sức mạnh thật sự.</p>
            </div>
            <div className="value-card reveal">
              <div className="value-num">05</div>
              <h3>Khách hàng là trung tâm</h3>
              <p className="value-quote">"Sự thịnh vượng của nhà thuốc là của chúng ta"</p>
              <p>Mọi quyết định đều đặt câu hỏi: "Điều này có giúp ích cho nhà thuốc không?"</p>
            </div>
            <div className="value-card reveal">
              <div className="value-num">06</div>
              <h3>Tập trung vào kết quả</h3>
              <p className="value-quote">"Làm thật — nói thật — tạo giá trị thật"</p>
              <p>Không marketing rỗng tuếch, không hứa hẹn không làm được. Kết quả là tiếng nói thuyết phục nhất.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="section section--soft">
        <div className="container">
          <div className="timeline-layout">
            <div className="timeline-content">
              <div className="reveal" style={{ maxWidth: '680px' }}>
                <span className="eyebrow">Hành trình</span>
                <h2>Những cột mốc đáng nhớ</h2>
              </div>
              <div className="timeline">
                <div className="timeline-item reveal">
                  <span className="year">12/2014</span>
                  <h4>Thành lập công ty</h4>
                  <p>Khởi đầu với việc khai trương Quầy 444 tại Trung tâm thuốc Hapulico, Hà Nội. Cái tên "Thế Thảo Pharma" do khách hàng yêu mến đặt — sau này trở thành tên chính thức của công ty.</p>
                </div>
                <div className="timeline-item reveal">
                  <span className="year">12/2022</span>
                  <h4>Khai trương văn phòng mới</h4>
                  <p>Chuyển về văn phòng 60B Nguyễn Huy Tưởng, P. Thanh Xuân, Hà Nội. Hoàn thiện cơ sở vật chất, mở rộng quy mô vận hành.</p>
                </div>
                <div className="timeline-item reveal">
                  <span className="year">03/2023</span>
                  <h4>Thành lập phòng Sale Online</h4>
                  <p>Hoàn thiện hệ thống Sale Online, đẩy mạnh phát triển trực tuyến và chuyển đổi số. Ra mắt thương hiệu độc quyền với 40 sản phẩm.</p>
                </div>
                <div className="timeline-item reveal">
                  <span className="year">2024</span>
                  <h4>Khởi xướng "Tủ Thuốc Cho Em"</h4>
                  <p>Khởi xướng dự án thiện nguyện "Tủ thuốc cho em" — mục tiêu mang 1.000 tủ thuốc đến các em nhỏ tại vùng khó khăn. Khẳng định trách nhiệm xã hội và tinh thần phụng sự.</p>
                </div>
                <div className="timeline-item reveal">
                  <span className="year">07/2025</span>
                  <h4>Tái cấu trúc doanh nghiệp</h4>
                  <p>Chuyển đổi từ Công ty TNHH Thế Thảo Pharma sang Công ty Cổ phần Thế Thảo Pharma. Tái cấu trúc mô hình kinh doanh và chuẩn hóa toàn diện thương hiệu.</p>
                </div>
                <div className="timeline-item reveal">
                  <span className="year">2026</span>
                  <h4>Chuẩn hóa thương hiệu toàn diện</h4>
                  <p>Triển khai dự án chuẩn hóa brand: Brand Guidelines, Company Profile, Bộ nhận diện, Sales Kit, Văn hóa nội bộ — xây nền tảng vững chắc cho giai đoạn tăng trưởng tiếp theo.</p>
                </div>
              </div>
            </div>

            <aside className="timeline-aside">
              <figure className="timeline-photo reveal">
                <img
                  src={getImage('timeline', 0, 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/timeline/0-1779247619525.webp')}
                  alt="Khởi đầu 2014"
                  loading="lazy"
                  width="1200"
                  height="900"
                />
                <figcaption>Đội ngũ Thế Thảo — 12 năm cùng đồng hành</figcaption>
              </figure>
              <figure className="timeline-photo reveal">
                <img
                  src={getImage('timeline', 1, 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/timeline/1-1779247578298.webp')}
                  alt="Mốc 10 năm — 2024"
                  loading="lazy"
                  width="1200"
                  height="900"
                />
                <figcaption>Văn phòng mới — 60B Nguyễn Huy Tưởng, Hà Nội</figcaption>
              </figure>
            </aside>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section" style={{ paddingTop: 0 }}>
        <div className="container">
          <div className="cta-strip reveal">
            <div>
              <h2>Cùng Thế Thảo viết tiếp hành trình</h2>
              <p>
                Chúng tôi đang tìm những con người tử tế, ham học và dám làm. Khám phá cơ hội nghề nghiệp tại Thế Thảo Pharma.
              </p>
            </div>
            <Link className="btn btn--primary" to="/tuyen-dung">
              Xem vị trí tuyển dụng
              <svg className="arr" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
